import { AxiosInstance } from 'axios';

export abstract class AxiosProviderRepository {
  constructor(
    protected readonly axios: AxiosInstance,
    protected readonly axiosPublic?: AxiosInstance,
  ) {}
}
